/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：工作台相关接口
 */
import { get, post } from '@common/http'

/**
 * 获取数据
 * @param param
 * @returns {*}
 */
export const getData = param => get('/getData', param)

/**
 * 添加数据
 * @param param
 * @returns {*}
 */
export const addData = param => post('/getData', param)

/**
 * 用户到期时间
 * @param param
 * @returns {*}
 */
export const getRenew = param => get('/tenant/getTenantUserInfo', param)

/**
 * 续费
 * @param param
 * @returns {*}
 */
export const getQrPay = param => get('/order/createRenewQrCode', param)

/**
 * 短信充值
 * @param param
 * @returns {*}
 */
export const createRechargeQrCode = param => get('/order/createRechargeQrCode', param)
/**
 * 客户反馈待回复
 * @param param
 * @returns {*}
 */
export const getFeedBackTotal = param => get('/t-tenant-customer-feedback/countFeedBackNum', param)

/**
 * 查询字典
 * @body data
 * @dictName {String}
 * @dictCode {String}
 */
export const queryDictionary = data => post('/dict/info', data)

/**
 * 添加字典
 * @body data
 * @dictType {String} 字典编码类型
 * @dictCode {String} 字典编码  DC_100
 * @dictName {String} 字典名称  充值卡充开
 * @content {String} 字典数据内容  {"validation":"validate(required,maxlength(6), number)"}
 * @REMARK {String} 备注  积分/元
 */
export const addDictionary = data => post('/dict', data)

// 获取打卡二维码
export const getWechatPunchQRCode = _ => get('/workAttendance/getOpenCode')

// 获取打卡记录
export const getThePunchRecord = data => post('/workAttendance/getWorkAttendance', data)

// 获取班次
export const getShiftInformation = data => get('/dict/getWorkDate', data)

// 获取服务器时间
export const getServerTime = _ => get('/order/time')

// 设置时间



// WEBPACK FOOTER //
// ./src/api/workbench.js